"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_download__cloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dd654ade-326a-4b1f-8306-24e7e835588e",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 160 160"
  }, props), /*#__PURE__*/React.createElement("title", null, "main_icn_Cloud_download"), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 72,
    x2: 80,
    y2: 156,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "106 128 80 156 54 128",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "635a3ea9-16bb-467d-a020-8b52dd3a6979",
    "data-name": "<Pfad>",
    d: "M118.35,124s22.44.86,31.19-3a38.28,38.28,0,0,0,22.28-31c1.31-13.09-4.66-27.47-15.95-34.43-5.61-3.46-12.16-4.85-18.71-5.42a77.58,77.58,0,0,0-11.19.51A43.8,43.8,0,0,0,88.06,20.12a42.57,42.57,0,0,0-35.72,15.1,44.13,44.13,0,0,0-8.91,17.46c-.43,1.69-1.28,6.43-1.28,6.43A33.47,33.47,0,0,0,30.28,65.9C19.77,75.3,17.21,91.36,23.09,104c5.34,11.48,16.81,20,29.57,20h21",
    transform: "translate(-16 -16)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var _default = ic_download__cloud;
exports.default = _default;